import React, { Component } from "react";
import { connect } from "react-redux";
import MajorQuerySearchBox from "./components/MajorQuerySearchBox";
import SchoolItem from "./components/SchoolItem";
import SchoolHeader from "../../../components/School/SchoolHeader";
import SchoolFilter from "./components/SchoolFilter";
import Loading from "../../../components/Loading";
import ReturnTop from "../../../components/ReturnTop";
import ListErrorPrompt from "../../../components/ListErrorPrompt";
import { post, get } from "../../../utils/request";
var finished = true;
/**
 * 专业查询院校的列表组件
 */
class SchoolList extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      data: null,
      dataList: [],
      filterVisible: false,
      searchVisible: true,
      topVisible: false,
      filterData: null,
      headerNum: null,
      params: {
        major: null,
        pageNum: 1,
        pageSize: 10,
      },
    };
    this.removeListener = false;
  }
  componentWillMount() {
    let sessionMajor = JSON.parse(sessionStorage.getItem("query_major"));
    let major;
    // 先看看sessionStorage有没有major的数据，如果没有去redux里面看看
    if (sessionMajor === null) {
      major = this.props.major;
    } else {
      major = sessionMajor;
    }
    this.setState({
      ...this.state,
      params: {
        ...this.state.params,
        major: major,
      },
    });
  }
  /**
   * 在第一次渲染后调用
   */
  componentDidMount() {
    this.requestSchoolList();
    this.requestSchoolFilter();
    this.handleAddScroll();
  }
  componentDidUpdate() {
    setTimeout(() => {
      if (
        this.state.params.pageNum >= this.state.data.data.pages &&
        !this.removeListener
      ) {
        document.removeEventListener("scroll", this.handleScroll);
        this.removeListener = true;
      }
    }, 500);
  }

  componentWillUnmount() {
    if (!this.removeListener) {
      document.removeEventListener("scroll", this.handleScroll);
    }
  }
  render() {
    const { data, dataList, filterVisible, filterData, searchVisible } =
      this.state;
    return (
      <div ref={this.myRef}>
        <MajorQuerySearchBox
          handleVisibleFilter={this.handleVisibleFilter}
          placeholder={this.state.params.major}
          visible={searchVisible}
          handleVisibleSearch={this.handleVisibleSearch}
          name=""
        ></MajorQuerySearchBox>
        <SchoolHeader
          num={this.state.headerNum}
          visible={searchVisible}
        ></SchoolHeader>
        {filterData != null ? (
          <SchoolFilter
            visible={filterVisible}
            filterData={filterData}
            handleAddScroll={this.handleAddScroll}
            handleVisibleFilter={this.handleVisibleFilter}
            requestFilterSchoolList={this.requestFilterSchoolList.bind(this)}
            handleChangeParams={this.handleChangeParams.bind(this)}
          ></SchoolFilter>
        ) : (
          ""
        )}
        <div style={{ height: 74 }}></div>
        {this.state.headerNum === 0 && searchVisible === true ? (
          <div>
            <ListErrorPrompt
              imgSrc={require("../../../images/school/notice.png")}
              toptext=""
              bottomtext="什么也没发现，请确保输入正确"
            ></ListErrorPrompt>
          </div>
        ) : (
          ""
        )}
        {data != null ? (
          <div className={searchVisible ? "" : "display_none"}>
            {dataList.map((item, index) => {
              return (
                <SchoolItem
                  key={index}
                  item={item}
                  url="/schooldetail/"
                  from="majorquery/list"
                ></SchoolItem>
              );
            })}
            {this.state.params.pageNum < data.data.pages ? (
              <Loading></Loading>
            ) : (
              <div className="schoolList_shim"></div>
            )}
          </div>
        ) : (
          ""
        )}
        <div className="schoolList_shim"></div>

        <ReturnTop visible={this.state.topVisible}></ReturnTop>
      </div>
    );
  }
  /**
   *控制侧边栏条件过滤框的关闭和展示
   */
  handleVisibleFilter = () => {
    this.setState({
      ...this.state,
      filterVisible: !this.state.filterVisible,
    });
  };
  /**
   * 请求院校的过滤条件
   */
  requestSchoolFilter() {
    get("/public/v1/school/filter/1").then((res) => {
      this.setState({
        filterData: res.data,
      });
    });
  }
  /**
   * 请求专业条件下的院校列表
   */
  requestSchoolList() {
    let params = {
      major: this.state.params.major,
      limits: this.props.schoolFilter.limitFilterId,
      schoolLevelIds: this.props.schoolFilter.levelFilterId,
      schoolTagIds: this.props.schoolFilter.tagFilterId,
      schoolPropertyIds: this.props.schoolFilter.propertyFilterId,
      provinceIds: this.props.schoolFilter.provinceFilterId,
      pageNum: this.state.params.pageNum,
      pageSize: this.state.params.pageSize,
    };
    post("/public/v1/school/major/list", params).then((data) => {
      const newDataList = this.state.dataList.concat(data.data.list);
      this.setState({
        data: data,
        dataList: newDataList,
        headerNum: data.data.total,
      });
      finished = true;
    });
  }
  /**
   * 在点击侧边栏过滤条件的时候使用
   */
  requestFilterSchoolList() {
    let params = {
      major: this.state.params.major,
      limits: this.props.schoolFilter.limitFilterId,
      schoolLevelIds: this.props.schoolFilter.levelFilterId,
      schoolTagIds: this.props.schoolFilter.tagFilterId,
      schoolPropertyIds: this.props.schoolFilter.propertyFilterId,
      provinceIds: this.props.schoolFilter.provinceFilterId,
      pageNum: 1,
      pageSize: 10,
    };
    post("/public/v1/school/major/list", params).then((data) => {
      const newDataList = data.data.list;
      this.setState({
        data: data,
        dataList: newDataList,
        headerNum: data.data.total,
      });
      finished = true;
    });
  }
  /**
   * 院校过滤组件修改院校的请求参数
   */
  handleChangeParams(params) {
    //后续要去掉的方法
    this.setState({
      ...this.state,
      params: {
        ...this.state.params,
        pageNum: params.pageNum,
        pageSize: params.pageSize,
      },
    });
  }
  // 处理屏幕滚动事件，实现加载更多的效果
  handleScroll = () => {
    const scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
    const screenHeight = document.documentElement.clientHeight;
    const schoolListTop = this.myRef.current.offsetTop;
    const schoolListHeight = this.myRef.current.offsetHeight;
    if (
      finished &&
      scrollTop >= schoolListHeight + schoolListTop - screenHeight - 2
    ) {
      finished = false;
      setTimeout(() => {
        this.setState({
          params: {
            ...this.state.params,
            pageNum: this.state.params.pageNum + 1,
          },
        });
        this.requestSchoolList();
      }, 500);
    }
    if (scrollTop >= 1200) {
      this.setState({
        topVisible: true,
      });
    } else {
      this.setState({
        topVisible: false,
      });
    }
  };
  /**
   * 添加scroll事件监听
   */
  handleAddScroll = () => {
    document.addEventListener("scroll", this.handleScroll);
  };
}
const mapStateToProps = (state) => {
  return {
    schoolFilter: state.major2schoolfilter.schoolFilterData,
    major: state.majorquery.majorData.major,
  };
};
export default connect(mapStateToProps)(SchoolList);



// WEBPACK FOOTER //
// ./src/containers/MajorQuerySchool/SchoolList/index.js